module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAABLElEQVRYR+3WP0pDQRDH8e8UAU8Qm3QeJBCbYBGxCRbBLgcICDlCwMpTSMq8Niew19LORhHs80A35A8BheQ5mdkQZLaeZT/8dnZY4ciXHLmPAFpvKBKMBK0JWPdHD0aClQkUqQ/cA4/UuOZCPir3KArsPThJrwiN5ZmJZ0padP2QHsB3hPomlMQTJedeSH/gKkk3ZB6gIzIf0AmZF+iAtAOL9Aac7pwci9d9QpO2fComzLL0MMCV6o5LGR4eOEk/x8w2wTcDrmQx0FXLnuDfgGNm9OjKl0rncsXVwL1xPj24G2jC5QaacTmBLrhcQDecF/AF4Wz93Xqg5Gaf17rtddvHTJE6wAiYMuPWE+eToHawKevtCSoP1JYHUJvY7/pIMBK0JmDdHz347xOcAzzKbykatKQTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/right-arrow.png
// module id = Ajdy
// module chunks = 2